// @flow
import { colors } from 'bench-style-constants';
import { Icon, TextBlock } from 'bench-internal-theme';
import React from 'react';
import styled from 'styled-components';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
// $FlowFixMe - TS file
import { SplitFeatureFlags } from '../../features';
import TextColumn from '../TextColumn';
import IconColumn from '../IconColumn';
import { useMediaQuery } from 'react-responsive';
import breakpoints from '../../constants/breakpoints';

const SortColumnLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TableHeaderLayout = styled(TextBlock).attrs(() => ({
  color: colors.smoke,
  styleType: 'small',
  uppercase: true,
}))`
  // Ensures there's a "bottom border", but doesn't change the height
  align-items: center;
  background-color: ${colors.pearl};
  border-top: 1px solid ${colors.silt};
  box-shadow: 0 1px 0 ${colors.silt};
  height: 33px;
  display: grid;
  grid-column-gap: 16px;
  margin: 0 32px;
  padding: 8px;
  grid-template-columns: ${({ isLd, isHd, isTablet, isAssignCategoryImprovementEnabled }) => {
    if (isHd) {
      return isAssignCategoryImprovementEnabled
        ? `auto 240px 16px 64px 112px 112px 112px 112px 16px 16px`
        : `auto 16px 64px 112px 112px 112px 112px 112px 112px 16px 16px`;
    }
    if (isLd) {
      return isAssignCategoryImprovementEnabled
        ? `auto 240px 16px 64px 112px 112px 112px 16px 16px`
        : `auto 16px 64px 112px 112px 112px 112px 16px 16px`;
    }
    if (isTablet) {
      return isAssignCategoryImprovementEnabled
        ? `auto 240px 16px 64px 16px 16px`
        : `auto 16px 64px 112px 16px 16px`;
    }
    return `auto 16px 16px`;
  }};
`;

const LedgerAccountsTableHeader = () => {
  const isHd = useMediaQuery({ minWidth: breakpoints.hd });
  const isLd = useMediaQuery({ minWidth: breakpoints.ld });
  const isTablet = useMediaQuery({ minWidth: breakpoints.tablet });

  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;

  const isAssignCategoryImprovementEnabled =
    features[SplitFeatureFlags.ASSIGN_CATEGORY_IMPROVEMENT]?.value === FeatureValue.FEATURE_ON;

  return (
    <TableHeaderLayout
      isLd={isLd}
      isHd={isHd}
      isTablet={isTablet}
      isAssignCategoryImprovementEnabled={isAssignCategoryImprovementEnabled}
    >
      <SortColumnLayout>
        <TextColumn align="left" key="name">
          Name
        </TextColumn>
      </SortColumnLayout>
      {isTablet && isAssignCategoryImprovementEnabled && (
        <TextColumn align="left" key="displayGroup">
          Display Group
        </TextColumn>
      )}
      {isTablet && (
        <>
          <IconColumn key="notebook" title="Notes">
            <Icon title="Notes" color={colors.clay} icon="notebook" size="small" />
          </IconColumn>
          <TextColumn align="center" key="account">
            Account
          </TextColumn>
          {!isAssignCategoryImprovementEnabled && (
            <TextColumn align="left" key="statementDate">
              Statement Date
            </TextColumn>
          )}
        </>
      )}
      {isLd && (
        <>
          <TextColumn align="left" key="dateActive">
            Date Active
          </TextColumn>
          <TextColumn align="left" key="dateInactive">
            Date Inactive
          </TextColumn>
          {!isAssignCategoryImprovementEnabled && (
            <TextColumn align="left" key="volume">
              Volume
            </TextColumn>
          )}
        </>
      )}
      {isHd && (
        <>
          <TextColumn align="left" key="collection">
            Collection
          </TextColumn>
          <TextColumn align="left" key="optimization">
            Optimization
          </TextColumn>
        </>
      )}
      <IconColumn key="pencil" title="Edit">
        <Icon color={colors.clay} icon="pencil" size="small" />
      </IconColumn>
      <IconColumn key="trash" title="Delete">
        <Icon color={colors.clay} icon="close" size="small" />
      </IconColumn>
    </TableHeaderLayout>
  );
};

export default LedgerAccountsTableHeader;
